import type { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import {
  KeyboardAvoidingView as RNKCKeyboardAvoidingView,
  KeyboardGestureArea as RNKCKeyboardGestureArea,
} from 'react-native-keyboard-controller';
import useCustomHeaderHeight from '@/hooks/useCustomHeaderHeight';

const style = StyleSheet.create({
  keyboardAvoidingView: {
    flex: 1,
  },
  keyboardGestureArea: {
    flex: 1,
  },
});

export default function KeyboardAvoidingView({ children }: PropsWithChildren) {
  const headerHeight = useCustomHeaderHeight();

  return (
    <RNKCKeyboardAvoidingView
      keyboardVerticalOffset={headerHeight}
      style={style.keyboardAvoidingView}
      behavior="translate-with-padding"
    >
      <RNKCKeyboardGestureArea
        interpolator="ios"
        style={style.keyboardGestureArea}
      >
        {children}
      </RNKCKeyboardGestureArea>
    </RNKCKeyboardAvoidingView>
  );
}
